import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import PostSearch from "./PostSearch";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchPost } from "../../../redux/slice/postSlice";
import AddPost from "./addPost";
import { callDeletePost } from "../../../config/api";
import ModalPost from "./modalPost";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";

interface DataType {
  key: React.Key;
  idTopic: string;
  idCategory: string;
  description: string;
  image: string;
}

function Post() {
  const [searchData, setSearchData] = useState("");
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=10&sort=-createdAt"
  );
  const dispatch = useAppDispatch();
  const posts = useAppSelector((state) => state.post);
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Category",
      dataIndex: "categoryId",
      render: (text) => <span>{text?.name}</span>,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   render: (text) => {
    //     const slicedText = text?.slice(0, 50);
    //     let newText = slicedText?.length >= 50 ? `${slicedText}...` : text;
    //     return <span style={{ color: "#1677ff" }}>{newText}</span>;
    //   },
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => {
    //     const slicedText = text?.slice(0, 50);
    //     let newText = slicedText?.length >= 50 ? `${slicedText}...` : text;
    //     return <span style={{ color: "#1677ff" }}>{newText}</span>;
    //   },
    // },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalPost id={record._id} handleFetchPost={handleFetchPost} />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeletePost(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;
  query += "&populate=categoryId&fields=categoryId._id,categoryId.name";

  const handleDeletePost = async (id: string) => {
    const result = await callDeletePost(id);
    if (result.statusCode === 200) {
      handleFetchPost();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };
  const handleSearch = (paramSearch: any) => {
    setSearchData(paramSearch);
  };

  // query += searchData;

  const handleFetchPost = () => {
    dispatch(fetchPost({ query }));
  };
  useEffect(() => {
    handleFetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddPost handleFetchPost={handleFetchPost} />
      </>
    );
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <PostSearch handleSearch={handleSearch} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={posts?.result}
        total={posts?.meta.total}
        loading={posts.isFetching}
        modalAdd={handleModalCreate}
        name="Posts"
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default Post;
